import React, { Component } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Menu,
  MenuItem,
  Button,
  ListItemIcon,
  Link,
  IconButton,
} from '@material-ui/core';
import { Person, ArrowDropDown, ExitToApp, Menu as MenuIcon, VpnKey } from '@material-ui/icons';
import withTheme from '@material-ui/core/styles/withTheme';
import { getCookie, handleLogout } from '../../utils/utils';
import { Search } from '@material-ui/icons';
import ChangePasswordDialog from './ChangePasswordDialog';
import Swal from 'sweetalert2';

class BackOfficeHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      smallScreen: false,
      showMenu: false,
      changePasswordOpen: false,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize.bind(this));
    this.resize();
  }

  resize() {
    this.setState({ smallScreen: window.innerWidth <= 630, showMenu: window.innerWidth <= 959 });
  }

  handleClose = () => this.setState({ anchorEl: null });

  handleMenu = event => this.setState({ anchorEl: event.currentTarget });

  handleChangePassword = value => this.setState({ changePasswordOpen: value });

  onChangePasswordSuccess = () => {
    Swal.fire({
      icon: 'success',
      title: 'Contraseña actualizada',
      text: 'Su contraseña fue actualizada correctamente. Debe iniciar sesión nuevamente.',
      customClass: {
        container: 'my-swal',
      },
    }).then(() => handleLogout(this.props.history));
  };

  render() {
    let open = Boolean(this.state.anchorEl);
    return (
      <AppBar style={{ zIndex: 900, backgroundColor: '#25265d' }} position="static">
        <Toolbar style={{ justifyContent: 'space-between' }}>
          <div style={{ display: 'flex' }}>
            {this.state.showMenu && (
              <IconButton
                onClick={() => this.props.handleDrawerToggle()}
                style={{ padding: '0 10px 0 0' }}
              >
                <MenuIcon style={{ color: 'white' }} />
              </IconButton>
            )}
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 15 }}>
              <Link style={{ textDecoration: 'none' }} href={this.props.link}>
                <Typography variant="h6" style={{ color: 'white' }}>
                  {!this.state.smallScreen && this.props.title}
                </Typography>
              </Link>
            </div>
          </div>
          <div>
            <Link style={{ color: 'white', textDecoration: 'none' }} href="#/search">
              <Button color="inherit" style={{ height: '100%' }} startIcon={<Search />}>
                Search
              </Button>
            </Link>
            <Button
              onClick={this.handleMenu}
              color="inherit"
              startIcon={<Person />}
              endIcon={<ArrowDropDown />}
              style={{
                paddingTop: this.state.smallScreen ? 10 : 12,
                paddingBottom: this.state.smallScreen ? 10 : 12,
                color: 'white',
              }}
            >
              {getCookie('name')}
            </Button>
            <Menu
              id="menu-appbar"
              anchorEl={this.state.anchorEl}
              elevation={1}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              open={open}
              onClose={this.handleClose}
            >
              {getCookie('signUpOrigin') === 'local_user' && (
                <MenuItem
                  onClick={() => {
                    this.handleClose();
                    this.handleChangePassword(true);
                  }}
                  style={{ padding: 12 }}
                >
                  <ListItemIcon>
                    <VpnKey style={{ color: 'grey' }} />
                  </ListItemIcon>
                  <Typography variant="inherit" style={{ color: 'rgba(0,0,0,0.7)' }}>
                    Cambiar contraseña
                  </Typography>
                </MenuItem>
              )}
              <MenuItem onClick={() => handleLogout(this.props.history)} style={{ padding: 12 }}>
                <ListItemIcon>
                  <ExitToApp style={{ color: 'grey' }} />
                </ListItemIcon>
                <Typography variant="inherit" style={{ color: 'rgba(0,0,0,0.7)' }}>
                  Cerrar sesión
                </Typography>
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
        <ChangePasswordDialog
          open={this.state.changePasswordOpen}
          onClose={() => this.handleChangePassword(false)}
          onSubmit={this.onChangePasswordSuccess}
          history={this.props.history}
        />
      </AppBar>
    );
  }
}

export default withTheme(BackOfficeHeader);
